import styled from 'styled-components'
import { theme } from '../../../styles/theme'
import { mq } from '../../../styles/mq'

export const ScreenTitle = styled.h3`
  text-align: center;
  max-width: 860px;
  margin-inline: auto;
  margin-top: 0;

  ${mq.xlarge} {
    font-size: 5.6rem;
    max-width: 1024px;
    margin: auto;
  }
`
export const SilhouettesContainer = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1024px;
  aspect-ratio: 1;

  ${mq.medium} {
    aspect-ratio: 2;
  }
`
export const Silhouette = styled.div<{ $ani: boolean }>`
  position: absolute;
  width: 182px;

  width: 12.8%;
  ${mq.smallOnly} {
    width: 20%;
  }
  ${(props) => (props.$ani === true ? 'opacity: 1;' : 'opacity: 0;')}
  &:nth-child(1) {
    top: 0%;
    ${(props) => (props.$ani === true ? 'left: 20%;' : 'left: 10%;')}
    ${mq.smallOnly} {
      ${(props) => (props.$ani === true ? 'left: 0%;' : 'left: -10%;')}
    }
  }
  &:nth-child(2) {
    top: 40%;
    ${mq.smallOnly} {
      top: 50%;
    }
    transition-delay: 100ms;
    ${(props) => (props.$ani === true ? 'left: 0%;' : 'left: -10%;')}
  }
  &:nth-child(3) {
    top: 72%;
    ${mq.smallOnly} {
      top: 90%;
    }
    transition-delay: 200ms;
    ${(props) => (props.$ani === true ? 'left: 30%;' : 'left: 20%;')}
    ${mq.smallOnly} {
      ${(props) => (props.$ani === true ? 'left: 0;' : 'left: -10%;')}
    }
  }
  &:nth-child(4) {
    top: 48%;
    ${mq.smallOnly} {
      top: 68%;
    }
    ${mq.large} {
      top: 30%;
    }
    transition-delay: 300ms;

    ${(props) => (props.$ani === true ? 'right: 0;' : 'right: -10%;')}
    ${mq.medium} {
      ${(props) => (props.$ani === true ? 'right: 25%;' : 'right: 15%;')}
    }
  }
  &:nth-child(5) {
    top: 16%;
    ${mq.smallOnly} {
      top: 21%;
    }
    ${mq.large} {
      top: 0%;
    }
    transition-delay: 400ms;
    ${(props) => (props.$ani === true ? 'right: 0%;' : 'right: -10%;')}
  }
  svg {
    width: 100%;
  }
  transition: all 0.5s;
`

export const IconTextContainer = styled.div<{ $ani: boolean }>`
  position: absolute;
  top: 26%;
  font-family: skolar-latin, serif;
  font-size: 1.7rem;

  width: 164px;
  ${mq.medium}{
    width: 164px;
    font-size: 1.9rem;
  }
  ${mq.large}{
    width: 198px;
    font-size: 2.1rem;
  }
  ${mq.xlarge}{
  width: 216px;
    font-size: 2.4rem;
  }

  font-style: italic;
  transition: all .5s;
  span {
    display: block;
    font-family: 'Skolar Sans PE Condensed', sans-serif;
    font-weight: 800;
    font-style: normal;
  }
  &.left {
    ${(props) =>
      props.$ani === true
        ? 'left: calc(100% + 48px);'
        : 'left: calc(100% - 48px);'}
    &:before {
      content: '';
      position: absolute;
      display: block;
      width: 32px;
      height: 1px;
      top: 1.8rem;
      ${mq.large}{
      top: 2rem;
      }
      right: calc(100% + 8px);
      background: ${theme.colors.text};
    }
  }
  &.right {
    ${(props) =>
      props.$ani === true
        ? 'right: calc(100% + 48px);'
        : 'right: calc(100% - 48px);'}
    text-align: right;
    &:before {
      content: '';
      position: absolute;
      display: block;
      width: 32px;
      height: 1px;
      top: 1.8rem;
      ${mq.large}{
      top: 2rem;
      }
      left: calc(100% + 8px);
      background: ${theme.colors.text};
  }

`
